<template>
  <b-container fluid style="width:1750px">
    <div v-if="showoverlay" style="z-index: 999; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
      <b-spinner style="width: 3rem; height: 3rem;" label="Please wait..."></b-spinner>
    </div>
    <b-overlay class="overspin" :show="showoverlay" rounded="sm" fixed>

      <b-row class="py-3">
        <b-col>
          <h2>Order Details Report</h2>
        </b-col>
      </b-row>

      <b-row class="py-2">
        <b-col cols="1">Order Num</b-col>
        <b-col cols="2">Date</b-col>
        <b-col cols="1">Cust Name</b-col>
        <b-col cols="1">Cust Phone</b-col>
        <b-col cols="2">Cust Email</b-col>
      </b-row>
      <b-row class="py-2">
        <b-col cols="1"><b-form-input v-model="ordnum"></b-form-input></b-col>
        <b-col cols="2"><b-form-datepicker v-model="date"></b-form-datepicker></b-col>
        <b-col cols="1"><b-form-input v-model="cusname"></b-form-input></b-col>
        <b-col cols="1"><b-form-input v-model="cusphone"></b-form-input></b-col>
        <b-col cols="2"><b-form-input v-model="cusemail"></b-form-input></b-col>
      </b-row>
      <b-row class="py-2">
        <b-col cols="1"><b-button variant="light" @click="clearFilters">Clear</b-button></b-col>
        <b-col cols="1"><b-button variant="dark" @click="runOrderDetails()">Run Report</b-button></b-col>
      </b-row>
      <b-alert v-if="paramAlert" show>Please choose a parameter to filter on</b-alert>

      <b-table
       table-variant="dark"
       :items="results"
       :fields="fields"
      >
        <template #cell(time_taken)="data">
          {{ data.item.time_taken | toUSDateFormat(true) }}
        </template>

        <template #cell(pickup_time)="data">
          {{ data.item.pickup_time | toUSDateFormat }}
        </template>

        <template #cell(customer_phone)="data">
          {{ data.item.customer_phone | toUSPhoneNumber }}
        </template>

        <template #cell(staff_name)="data">
          {{ data.item.staff_first_name + ' ' + data.item.staff_last_name }}
        </template>

        <template #cell(subtotal)="data">
          {{ data.item.subtotal | toCurrency }}
        </template>

        <template #cell(discount)="data">
          {{ data.item.discount | toCurrency }}
        </template>

        <template #cell(surcharge)="data">
          {{ data.item.surcharge | toCurrency }}
        </template>

        <template #cell(tip)="data">
          {{ data.item.tip | toCurrency }}
        </template>

        <template #cell(tax)="data">
          {{ data.item.tax | toCurrency }}
        </template>

        <template #cell(total)="data">
          {{ data.item.total | toCurrency }}
        </template>

        <!-- ORDER LINES SUBTABLE -->
        <template #row-details="data">
          <b-table :items="data.item.orderlines" :fields="olfields" table-variant="light" hover fixed>
            <template #cell(line_total)="oldata">
              {{ oldata.item.line_total | toCurrency }}
            </template>

            <!-- LINE OPTIONS SUBTABLE -->
            <template #row-details="data">
              <div v-for="oph in data.item.options" :key="oph.id">
                <b-row style="font-size:90%;" v-for="opi in oph.options" :key="opi.id" class="my-0 py-0">
                  <b-col></b-col>
                  <b-col style="text-indent: 10px;">{{ opi.option_name }}</b-col>
                  <b-col></b-col>
                  <b-col>{{ opi.additional_price | toCurrency }}</b-col>
                  <b-col></b-col>
                </b-row>
              </div>
            </template>

          </b-table>
        </template>

      </b-table>
      <b-row>
        <b-col cols="3">
          Number of orders: {{ total_orders }}
        </b-col>
        <b-col cols="3">
          Average Order: {{ avg_order_amount| toCurrency }}
        </b-col>
        <b-col cols="3">
          Total Order Amount: {{ total_order_amount | toCurrency }}
        </b-col>
      </b-row>

      <b-pagination v-model="currentPage" :total-rows="total_orders" :per-page="limit" align="center" @change="changePage()"></b-pagination>
      <p style="text-align: center;">Total orders returned: {{ total_orders }}</p>
    </b-overlay>
  </b-container>
</template>


<script>
export default {
  name: "OrderDetails",
  data() {
    return {
      results: [],
      limit: 50,
      currentPage: 1,
      showoverlay: false,
      date: '',
      ordnum: '',
      cusname: '',
      cusphone: '',
      cusemail: '',
      total_orders: 0,
      total_order_amount: 0,
      avg_order_amount: 0,
      sortparams: '',
      fields: [
          'order_number',
          'time_taken',
          'pickup_time',
          'customer_name',
          'customer_phone',
          'customer_email',
          'staff_name',
          'subtotal',
          'discount',
          'surcharge',
          'tip',
          'tax',
          'total',
          'notes'
      ],
      olfields: [
        'line_number',
        'item_name',
        'quantity',
        'line_total',
        'line_notes'
      ],
      optfields: [
        'option_name',
        'additional_price'
      ],
      paramAlert: false,
    };
  },

  computed: {
    ordnumfilter: function() {
      if (this.ordnum) {
        return '&ordernum=eq:'+this.ordnum;
      } else {
        return '';
      }
    },

    datefilter: function() {
      if (this.date) {
        return '&date=eq:'+this.date;
      } else {
        return '';
      }
    },

    cusnamefilter: function() {
      if (this.cusname) {
        return '&cusname=like:'+this.cusname;
      } else {
        return '';
      }
    },

    cusphonefilter: function() {
      if (this.cusphone) {
        return '&cusphone=like:'+this.cusphone;
      } else {
        return '';
      }
    },

    cusemailfilter: function() {
      if (this.cusemail) {
        return '&cusemail=like:'+this.cusemail;
      } else {
        return '';
      }
    },

    // sortparams: function() {
    //   if (sortparam=='') {
    //     return '';
    //   } else {
    //     var sortdir = (sortbydesc === true) ? '-' : '+';
    //     return '&sortby=' + sortdir + sortparam;
    //   }
    // },

    // all pagination, filtering and sorting info collected here for housekeeping purposes
    urlext: function() {
      return "?page="+this.currentPage
        +"&limit="+this.limit
        +this.ordnumfilter
        +this.datefilter
        +this.cusnamefilter
        +this.cusphonefilter
        +this.cusemailfilter
        +this.sortparams;
    }

  },

  methods: {
    validateParams() {
      if (!this.date && !this.ordnum && !this.cusname && !this.cusphone && !this.cusemail) {
        this.paramAlert = true;
        return false;
      }
    },

    async runOrderDetails() {
      if (this.validateParams() == false) {
        return;
      }
      this.showoverlay = true;
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      const { data } = await this.$api.get("reports/order-details"+this.urlext, {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      this.results = await data.order_details;
      // Set Show Details = true for each Order
      this.results.map(res=>(
        res._showDetails=true,
        res.orderlines.map(ol=>{
          if (ol.options.length>0) {
            ol._showDetails=true,
            this.buildOptionDetails(ol)
          }
        })
      ));
      this.total_orders = data.total_orders;
      this.total_order_amount = data.total_order_amount;
      this.avg_order_amount = data.avg_order_amount;
      this.showoverlay = false;
    },

    buildOptionDetails(ol) {
      ol.options.map(
        oph=>oph.options.map(
          opi=>(
            opi.additional_price=(Math.round((Number(oph.add_price)+Number(opi.add_price))*100)/100).toFixed(2),
            opi.option_name=opi.name+ ' ('+oph.name+')'
          )
        )
      )
    },

    changePage() {
      this.showoverlay = true;
      this.runOrderOverview();
    },

    clearFilters() {
      this.date = '';
      this.ordnum = '';
      this.cusname = '';
      this.cusphone = '';
      this.cusemail = '';
    },

    // updateSortParams(sortparam, sortbydesc) {
    //   if (sortparam=='') {
    //     this.sortparams='';
    //   } else {
    //     var sortdir = (sortbydesc === true) ? '-' : '+';
    //     this.sortparams = '&sortby=' + sortdir + sortparam;
    //   }
    //   this.showoverlay = true;
    //   this.fetchTransactions();
    // },
  },

};
</script>
<style>
  .overspin .spinner-border {
    visibility: hidden;
  }

</style>
